<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    通新岭站<br>
站点介绍<br>
车站位于深圳市福田区上步中路与红荔路交叉口南侧，沿上步中路南北向布置，该站为地下三层岛式车站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:22	23:56	3号线	2分15-20秒	4分30秒<br>
双龙	06:01	23:17	3号线	2分15-20秒	4分30秒<br>
科学馆	06:26	00:09	6号线	3分24秒	6分20秒<br>
松岗	06:22	23:02	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:31	23:55	3号线	3分15秒	5分钟<br>
双龙	06:02	23:17	3号线	3分15秒	5分钟<br>
科学馆	06:25	00:09	6号线	4分45秒	6分钟<br>
松岗	06:22	23:02	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:31	00:55	3号线	3分15秒	5分钟<br>
双龙	06:02	00:17	3号线	3分15秒	5分钟<br>
科学馆	06:25	01:09	6号线	4分45秒	6分钟<br>
松岗	06:22	00:02	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A1出入口:<br>
上步中路西侧，红荔路南侧（西），深圳外国语学校<br><br>
A2出入口:<br>
红荔路（南）、上步中路（西）、深圳外国语学校初中部、四川大厦、深堪大厦、上步信托工贸大厦、深圳市公安局交通警察局福田大队<br><br>
E1/E2出入口:<br>
上步中路西侧（南），红荔路南侧（东），荔园小学，荔枝公园<br><br>
F出入口:<br>
上步中路西侧（南），红荔路南侧（西），深圳市文化馆<br><br>
B出入口:<br>
红荔路（南）、上步中路（东）、同德路、荔园小学、市少儿图书馆、园岭村、通新岭小区<br><br>
C出入口:<br>
红荔路（北）、上步中路（东）、园岭西路、园岭小学、园岭新村、荔湖花苑大厦、中国邮政储蓄<br><br>
D出入口:<br>
红荔路（北）、上步中路（西）、妇儿医院、百花二路、深圳实验小学、深圳实验中学、深圳市妇幼保健院（总院）、园岭街道办事处、深圳体育馆<br><br>
公交换乘信息<br>
A1出入口:<br>
公交站名： 妇幼保健院（注 红荔路）<br>
108路、10路、12路、13路、225路、303路、M183、64路、M105路、M481路、371、N25<br><br>
A1出入口:<br>
公交站名： 荔园小学（注 上步中路）<br>
M132路、M389路、M555路、M555(原65）路、N17路、4路、8路、9路、12路、8路、202路<br><br>
B出入口:<br>
公交站名： 少儿图书馆（注 红荔路）<br>
7路、108路、10路、13路、202路、225路、303路、64路、80路、M183路）、M105路、M207路、322路、M481、M555路、N25路<br><br>
C出入口:<br>
公交站名： 少儿图书馆（注 红荔路）<br>
7路、108路、10路、13路、202路、225路、303路、64路、80路、M555路、M481、M207路、M183路、M105路、322路、N25<br><br>
D出入口:<br>
公交站名： 妇幼保健院（注 红荔路）<br>
108路、10路、12路、13路、225路、303路、64路、M105路、M481路、183路、N25路、371路<br><br>
A2出入口:<br>
公交站名： 荔园小学通新岭校区<br>
4、8、12、80、202、393、M132、M389、M555、N17、高峰专线29<br><br>
E1出入口:<br>
公交站名： 荔园小学通新岭校区<br>
4、8、12、80、202、393、M132、M389、M555、N17、高峰专线29<br><br>
E2出入口:<br>
公交站名： 少儿图书馆公交站<br>
N25、M105、M183、M481、M555、7、10、13、64、79、80、108、202、225、303、322<br><br>
F出入口:<br>
公交站名： 市总工会<br>
4、8、12、202、M132、N17<br><br>
F出入口:<br>
公交站名： 建艺大厦1<br>
75、80、M389、M555<br><br>
F出入口:<br>
公交站名： 建艺大厦2<br>
M383<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>